import axios from "axios";
import { adminUsersListRequest, googleLoginRequest, loginRequest, profileUpdateRequest, userProfileRequest } from "../../utils/capitalRequest";


export const loginAction = (userName, password) => async (dispatch) => {
  try {
    dispatch({ type: 'userDataRequest' });
    const { data } = await loginRequest({email:userName, password});

    if(data.status === false){
      dispatch({ type: 'userDataFailure', payload: data.message });
    }else{
      dispatch({ type: 'userDataSuccess', payload: data });
      localStorage.setItem('token', data.data?.token);
      localStorage.setItem('user', JSON.stringify(data));
      var expires = (7*24*60*60);
      var now = Date.now()
      var schedule = now + expires * 1000;
      localStorage.setItem('user_expiresIn', schedule);
    }
  } catch (error) {
    dispatch({ type: 'userDataFailure', payload: error.response.data.message });
  }
};


export const googleLoginAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: 'googleLoginRequest' });
    const { data } = await googleLoginRequest(params);

    if(data.status === false){
      dispatch({ type: 'googleLoginFailure', payload: data.message });
    }else{
      dispatch({ type: 'googleLoginSuccess', payload: data });
      localStorage.setItem('token', data.data?.token);
      localStorage.setItem('user', JSON.stringify(data));
      var expires = (7*24*60*60);
      var now = Date.now()
      var schedule = now + expires * 1000;
      localStorage.setItem('user_expiresIn', schedule);
    }
  } catch (error) {
    dispatch({ type: 'googleLoginFailure', payload: error.response.data.message });
  }
};



export const profileUpdateAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: 'profileUpdateRequest' });
    const { data } = await profileUpdateRequest(params);

    if(data.status === false){
      dispatch({ type: 'profileUpdateFailure', payload: data.msg });
    }else{
      dispatch({ type: 'profileUpdateSuccess', payload: data?.data });
    }
  } catch (error) {
    dispatch({ type: 'profileUpdateFailure', payload: error.response});
  }
};


export const adminUserListAction = () => async (dispatch) => {
  try {
    dispatch({ type: 'adminUserListRequest' });
    const { data } = await adminUsersListRequest();

    if(data.status === false){
      dispatch({ type: 'adminUserListFailure', payload: data.msg });
    }else{
      dispatch({ type: 'adminUserListSuccess', payload: data?.data });
    }
  } catch (error) {
    dispatch({ type: 'adminUserListFailure', payload: error.response});
  }
};


export const userProfileAction = () => async (dispatch) => {
  try {
    dispatch({ type: 'userProfileRequest' });
    const { data } = await userProfileRequest();
    localStorage.setItem('user', JSON.stringify(data));

    if(data.status === false){
      dispatch({ type: 'userProfileFailure', payload: data.msg });
    }else{
      dispatch({ type: 'userProfileSuccess', payload: data?.data });
    }
  } catch (error) {
    dispatch({ type: 'userProfileFailure', payload: error.response});
  }
};


